<div id="lease-error" class="form-container">
    <div class="row">
      <div class="col-md-12 text-center">
        <p><i id="renewalErrorIcon" class="material-icons renewalIcon">error_outline</i></p>
        <p>The following error was encountered:</p>
        <p>{{ errorMessage }}</p>
        <p> If this error persists please contact us at our dedicated resident services center at <b>855.676.1680</b>. Thank you.</p>
      </div>
    </div>
    <hr />
  </div>